<template>
  <HighlightsWidget
    v-bind="users"
    :disableZeroState="true"
    :flexLayout="true"
    title="Users"
    v-on="$listeners"
  >
    <template
      v-if="!users.isLoading"
      v-slot:mainContent
    >
      <div :class="$style.container">
        <section>
          <a
            :class="$style.resourcesAllLink"
            href="#"
            @click.prevent="$emit('navigationMethod', 'Users', 'bound')"
          >Bound</a>
          <span :class="[$style.count, 'UsersBound__Count']">
            {{ users.bound.totalCount }}
          </span>
          <ul v-if="users.bound.results.length">
            <li
              v-for="(n, index) in 3"
              :key="index"
              :class="$style.highlightsListItem"
            >
              <a
                v-if="users.bound.results[index]"
                :class="$style.resourceLink"
                :href="`#/users/${users.bound.results[index].id}/details`"
              >
                {{ users.bound.results[index].username }}
              </a>
              <p
                v-else
                :class="$style.emptyItem"
              >
                -
              </p>
            </li>
          </ul>
          <div
            v-else
            :class="$style.emptyMessageContainer"
          >
            <a
              href="#"
              @click.prevent="$emit('navigationMethod', 'Users')"
            >Add a user to this device</a>
          </div>
        </section>
        <section>
          <a
            :class="$style.resourcesAllLink"
            href="#"
            @click.prevent="$emit('navigationMethod', 'Details', 'unmanaged')"
          >Unmanaged</a>
          <span :class="[$style.count, 'UsersUnmanaged__Count']">
            {{ users.unmanaged.totalCount }}
          </span>
          <ul>
            <li
              v-for="(n, index) in 3"
              :key="index"
              :class="$style.highlightsListItem"
            >
              <a
                v-if="users.unmanaged.results[index]"
                :class="$style.resourceLink"
                href="#"
                @click.prevent="$emit('navigationMethod', 'Details', 'unmanaged')"
              >
                {{ users.unmanaged.results[index].username }}
              </a>
              <p
                v-else
                :class="$style.emptyItem"
              >
                -
              </p>
            </li>
          </ul>
        </section>
      </div>
    </template>
  </HighlightsWidget>
</template>

<script>

import HighlightsWidget from 'client/components/Highlights/HighlightsWidget.vue';

export default {
  name: 'DeviceUsersWidget',

  components: {
    HighlightsWidget,
  },

  props: {
    users: {
      type: Object,
      default: () => ({
        bound: [],
        unmanaged: [],
      }),
    },
  },
};
</script>

<style module>
@import '../../../components/Highlights/css/highlights.css';

@value (jcGrey300, jcGrey600, jcBlack) from '~css/brand-colors.css';

.container {
  display: flex;
  padding: 0;
}

.container section {
  flex-basis: 33%;
  text-align: left;
}

.container ul {
  list-style: none;
  padding: 10px 0 0;
}

.emptyItem {
  font-size: 14px;
  margin-bottom: 0;
}

.count {
  background-color: jcGrey300;
  border-radius: 20px;
  color: jcBlack;
  padding: 0.1rem;
  padding-right: 0.5rem;
  text-decoration: none;
}

.emptyMessageContainer {
  margin: 13px 0;
  padding-top: 10px;
}

</style>
